import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
  selector: '[appAllownumbersonly]',
})
export class AllownumbersonlyDirective {
  constructor(private readonly el: ElementRef) {}
  @HostListener('input', ['$event']) onInputChange(event: any): void {
    const initalValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '').slice(0, 2);
    if (this.el.nativeElement.value.length === 2 && this.el.nativeElement.value.startsWith('0')) {
      this.el.nativeElement.value = this.el.nativeElement.value.replace('0', '');
    }
    if (+this.el.nativeElement.value > 10) {
      this.el.nativeElement.value = '10';
    }
    if (initalValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
